module.exports = __webpack_public_path__ + "img/apple_pick_hand_hold_run_q90_lossy.9256b4f3.webp";